namespace TabAurous.OMS {
    export interface ProductMasterRow {
        ProductId?: number;
        ProductTypeId?: number;
        ProductCode?: string;
        ProductName?: string;
        ItemTypeId?: number;
        AttributeId?: number;
        Pieces?: number;
        Weight?: number;
        Parts?: number;
        Variance?: number;
        PointerWeight?: number;
        NetWeight?: number;
        DiamondPieces?: number;
        DiamondWeight?: number;
        StonePieces?: number;
        StoneWeight?: number;
        OtherPieces?: number;
        OtherWeight?: number;
        Rate?: number;
        UnitLabour?: number;
        SalesPrice?: number;
        PriceMarkup?: number;
        LaborMarkup?: number;
        CalcOnId?: number;
        CalcUnitId?: number;
        CostMethodId?: Common.CostMethod;
        SalesCostMethodId?: Common.CostMethod;
        PurchaseCostMethodId?: Common.CostMethod;
        SettingId?: number;
        ImageName?: string;
        Image1?: string;
        Image2?: string;
        Image3?: string;
        Image4?: string;
        Image5?: string;
        Image6?: string;
        Image7?: string;
        Image8?: string;
        Video1?: string;
        Video2?: string;
        ServerDate?: string;
        CreationDate?: string;
        CreationVoucherId?: number;
        Remarks?: string;
        IsDisabled?: boolean;
        HasBom?: boolean;
        IsDefaultSKU?: boolean;
        ForExchange?: boolean;
        ParentDesign?: string;
        SKU?: string;
        DesignId?: number;
        IsNew?: boolean;
        IsCustomerItem?: boolean;
        IsFeatured?: boolean;
        Volume?: number;
        Volume1?: number;
        Volume2?: number;
        QualityInspectionId?: number;
        MappingId?: number;
        IsConfigurable?: boolean;
        HSN?: string;
        TaxCode?: string;
        ProductTypeName?: string;
        Attribute?: string;
        ItemType?: string;
        CategoryId?: number;
        CategoryName?: string;
        SubCategoryId?: number;
        SubCategoryName?: string;
        BrandId?: number;
        CollectionId?: number;
        SuperTypeId?: number;
        ProductSizeId?: number;
        BrandName?: string;
        CollectionName?: string;
        SuperTypeName?: string;
        MetalName?: string;
        MetalId?: number;
        KaratId?: number;
        MetalColorId?: number;
        KaratName?: string;
        MetalColorName?: string;
        Purity?: number;
        MinPurity?: number;
        MaxPurity?: number;
        StdPurity?: number;
        ShapeId?: number;
        StoneColorId?: number;
        QualityId?: number;
        StoneSizeId?: number;
        SieveId?: number;
        StoneCutId?: number;
        StonePolishId?: number;
        StoneSymmetryId?: number;
        StoneFluorescenceId?: number;
        StoneCuletId?: number;
        StoneGirdleId?: number;
        StoneTable?: string;
        StoneDepth?: string;
        StoneSizeName?: string;
        SieveName?: string;
        StoneColoreName?: string;
        GroupSieveName?: string;
        QualityName?: string;
        ShapeName?: string;
        BOMDetails?: ProductBOMRow[];
        LaborDetails?: ProductMasterLaborRow[];
        InspectionDetails?: ProductInspectionRow[];
        SequenceDetails?: ProductSequenceRow[];
        MoldsDetails?: ProductMoldsRow[];
        ProductPartyDetails?: ProductPartyDetailsRow[];
        MFAmount?: number;
        DiamondDiscountPercent?: number;
        ProductEnquiryType?: string;
        PurchaseRate?: number;
        SalesRate?: number;
        CostId?: number;
    }

    export namespace ProductMasterRow {
        export const idProperty = 'ProductId';
        export const nameProperty = 'ProductCode';
        export const localTextPrefix = 'OMS.ProductMaster';
        export const deletePermission = 'Products:Delete';
        export const insertPermission = 'Products:Add';
        export const readPermission = '*';
        export const updatePermission = 'Products:Edit';

        export declare const enum Fields {
            ProductId = "ProductId",
            ProductTypeId = "ProductTypeId",
            ProductCode = "ProductCode",
            ProductName = "ProductName",
            ItemTypeId = "ItemTypeId",
            AttributeId = "AttributeId",
            Pieces = "Pieces",
            Weight = "Weight",
            Parts = "Parts",
            Variance = "Variance",
            PointerWeight = "PointerWeight",
            NetWeight = "NetWeight",
            DiamondPieces = "DiamondPieces",
            DiamondWeight = "DiamondWeight",
            StonePieces = "StonePieces",
            StoneWeight = "StoneWeight",
            OtherPieces = "OtherPieces",
            OtherWeight = "OtherWeight",
            Rate = "Rate",
            UnitLabour = "UnitLabour",
            SalesPrice = "SalesPrice",
            PriceMarkup = "PriceMarkup",
            LaborMarkup = "LaborMarkup",
            CalcOnId = "CalcOnId",
            CalcUnitId = "CalcUnitId",
            CostMethodId = "CostMethodId",
            SalesCostMethodId = "SalesCostMethodId",
            PurchaseCostMethodId = "PurchaseCostMethodId",
            SettingId = "SettingId",
            ImageName = "ImageName",
            Image1 = "Image1",
            Image2 = "Image2",
            Image3 = "Image3",
            Image4 = "Image4",
            Image5 = "Image5",
            Image6 = "Image6",
            Image7 = "Image7",
            Image8 = "Image8",
            Video1 = "Video1",
            Video2 = "Video2",
            ServerDate = "ServerDate",
            CreationDate = "CreationDate",
            CreationVoucherId = "CreationVoucherId",
            Remarks = "Remarks",
            IsDisabled = "IsDisabled",
            HasBom = "HasBom",
            IsDefaultSKU = "IsDefaultSKU",
            ForExchange = "ForExchange",
            ParentDesign = "ParentDesign",
            SKU = "SKU",
            DesignId = "DesignId",
            IsNew = "IsNew",
            IsCustomerItem = "IsCustomerItem",
            IsFeatured = "IsFeatured",
            Volume = "Volume",
            Volume1 = "Volume1",
            Volume2 = "Volume2",
            QualityInspectionId = "QualityInspectionId",
            MappingId = "MappingId",
            IsConfigurable = "IsConfigurable",
            HSN = "HSN",
            TaxCode = "TaxCode",
            ProductTypeName = "ProductTypeName",
            Attribute = "Attribute",
            ItemType = "ItemType",
            CategoryId = "CategoryId",
            CategoryName = "CategoryName",
            SubCategoryId = "SubCategoryId",
            SubCategoryName = "SubCategoryName",
            BrandId = "BrandId",
            CollectionId = "CollectionId",
            SuperTypeId = "SuperTypeId",
            ProductSizeId = "ProductSizeId",
            BrandName = "BrandName",
            CollectionName = "CollectionName",
            SuperTypeName = "SuperTypeName",
            MetalName = "MetalName",
            MetalId = "MetalId",
            KaratId = "KaratId",
            MetalColorId = "MetalColorId",
            KaratName = "KaratName",
            MetalColorName = "MetalColorName",
            Purity = "Purity",
            MinPurity = "MinPurity",
            MaxPurity = "MaxPurity",
            StdPurity = "StdPurity",
            ShapeId = "ShapeId",
            StoneColorId = "StoneColorId",
            QualityId = "QualityId",
            StoneSizeId = "StoneSizeId",
            SieveId = "SieveId",
            StoneCutId = "StoneCutId",
            StonePolishId = "StonePolishId",
            StoneSymmetryId = "StoneSymmetryId",
            StoneFluorescenceId = "StoneFluorescenceId",
            StoneCuletId = "StoneCuletId",
            StoneGirdleId = "StoneGirdleId",
            StoneTable = "StoneTable",
            StoneDepth = "StoneDepth",
            StoneSizeName = "StoneSizeName",
            SieveName = "SieveName",
            StoneColoreName = "StoneColoreName",
            GroupSieveName = "GroupSieveName",
            QualityName = "QualityName",
            ShapeName = "ShapeName",
            BOMDetails = "BOMDetails",
            LaborDetails = "LaborDetails",
            InspectionDetails = "InspectionDetails",
            SequenceDetails = "SequenceDetails",
            MoldsDetails = "MoldsDetails",
            ProductPartyDetails = "ProductPartyDetails",
            MFAmount = "MFAmount",
            DiamondDiscountPercent = "DiamondDiscountPercent",
            ProductEnquiryType = "ProductEnquiryType",
            PurchaseRate = "PurchaseRate",
            SalesRate = "SalesRate",
            CostId = "CostId"
        }
    }
}
